import { render, staticRenderFns } from "./DesktopServicePromotion.vue?vue&type=template&id=7c09a961&"
import script from "./DesktopServicePromotion.vue?vue&type=script&lang=js&"
export * from "./DesktopServicePromotion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c09a961')) {
      api.createRecord('7c09a961', component.options)
    } else {
      api.reload('7c09a961', component.options)
    }
    module.hot.accept("./DesktopServicePromotion.vue?vue&type=template&id=7c09a961&", function () {
      api.rerender('7c09a961', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "auth_ui/static/vue-src/components/ServicePromotion/DesktopServicePromotion.vue"
export default component.exports